export const SET_LOADING = 'SET_LOADING';
export const SET_LOCOMOTIVE_LIST = 'SET_LOCOMOTIVE_LIST';
export const SET_LOCOMOTIVE_LIST_LOADING = 'SET_LOCOMOTIVE_LIST_LOADING';
export const ADD_LOCOMOTIVE = 'ADD_LOCOMOTIVE';
export const SET_EDITED_LOCOMOTIVE = 'SET_EDITED_LOCOMOTIVE';
